<template>
<div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.companies.manager.user.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row" v-if="data._id">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.user.label.data.company.decription')}}
                                </p>
                                <form>
                                    <div class="form-row" v-if="data.status == 'ACTIVE'">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.brand.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>

                                        <div class="form-group col-md-3 text-center">
                                            <br/><br/>
                                            <button v-on:click="confirmArchive" class="text-dark-gray btn btn-warning w-50">{{$t('string.msg.status.archive')}}</button>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.fantasyName')}}
                                            </label>
                                            <input type="text" v-model="data.fantasyName" class="form-control" :placeholder="$t('string.msg.company.placeholder.fantasyName')">
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.socialName')}}
                                            </label>
                                            <input type="text" v-model="data.socialName" class="form-control" :placeholder="$t('string.msg.company.placeholder.socialName')">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.document')}}
                                            </label>
                                            <input type="tel" v-model="data.document" v-mask="['###.###.###-##', '##.###.###/####-##']" class="form-control" :placeholder="$t('string.msg.company.placeholder.document')">
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.company.label.stateSubscription')}}
                                            </label>
                                            <input v-model="data.stateSubscription" type="text" class="form-control" :placeholder='$t("string.msg.company.placeholder.stateSubscription")' v-mask="['###.###.###.###']"/>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code v-if="!data._id" class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.primaryPhone')}}
                                            </label>
                                            <input v-model="data.primaryPhone" type="text" class="form-control" :placeholder='$t("string.msg.company.placeholder.primaryPhone")' v-mask="['(##) ####-####', '(##) #####-####']"/>
                                        </div>

                                         <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code v-if="!data._id" class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.main.email')}}
                                            </label>
                                            <input type="text" v-model="data.email" class="form-control" :placeholder="$t('string.msg.company.placeholder.main.email')">
                                        </div>

                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.company.label.secondaryPhone')}}
                                            </label>
                                            <input v-model="data.secondaryPhone" type="text" class="form-control" :placeholder='$t("string.msg.company.placeholder.primaryPhone")' v-mask="['(##) ####-####', '(##) #####-####']"/>
                                        </div>
                                          <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.company.label.talkto')}}
                                            </label>
                                            <input v-model="data.talkTo" type="text" class="form-control" :placeholder='$t("string.msg.company.placeholder.talkto")'/>
                                        </div>

                                    </div>

                                    <div class="form-row">
                                         <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.isbranch')}}
                                            </label>
                                            <select v-model="data.isBranch" class="form-control">
                                                <option :value="false">{{$t('string.msg.no')}}</option>
                                                <option :value="true">{{$t('string.msg.yes')}}</option>
                                            </select>
                                        </div>

                                        <div v-if="data.isBranch == true" class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.document.main')}}
                                            </label>
                                            <input type="tel" v-mask="'##.###.###/####-##'"  v-model="data.mainCompany" class="form-control" :placeholder="$t('string.msg.company.placeholder.document')">
                                        </div>
                                            
                                    </div>

                                    <div class="form-row ">
                                        <div class="form-group col-sm-2">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.cep')}}
                                            </label>
                                            <input @blur="loadInfosByCEP" v-mask="'#####-###'" v-model="data.address.cep" type="tel" class="form-control" :placeholder="$t('string.msg.company.label.cep')" />
                                        </div>
                                    </div>
                                    <div v-if="data.address.cep && data.address.cep.length == 9" class="form-row ">
                                        <div class="form-group col-sm-2">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.state')}}    
                                            </label>
                                            <select v-model="data.address.state" class="form-control select2">
                                                <option value="-1" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                                <option value="AC">AC</option>
                                                <option value="AL">AL</option>
                                                <option value="AP">AP</option>
                                                <option value="AM">AM</option>
                                                <option value="BA">BA</option>
                                                <option value="CE">CE</option>
                                                <option value="DF">DF</option>
                                                <option value="ES">ES</option>
                                                <option value="GO">GO</option>
                                                <option value="MA">MA</option>
                                                <option value="MT">MT</option>
                                                <option value="MS">MS</option>
                                                <option value="MG">MG</option>
                                                <option value="PA">PA</option> 
                                                <option value="PB">PB</option>
                                                <option value="PR">PR</option>
                                                <option value="PE">PE</option>
                                                <option value="PI">PI</option>
                                                <option value="RJ">RJ</option>
                                                <option value="RN">RN</option>
                                                <option value="RS">RS</option>
                                                <option value="RO">RO</option>
                                                <option value="RR">RR</option>
                                                <option value="SC">SC</option>
                                                <option value="SP">SP</option>
                                                <option value="SE">SE</option>
                                                <option value="TO">TO</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-4">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.city')}}
                                            </label>
                                            <input v-model="data.address.city" type="text" class="form-control" :placeholder="$t('string.msg.company.label.city')" />
                                        </div>
                                        <div class="form-group col-sm-4">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.street')}}
                                            </label>
                                            <input v-model="data.address.address" type="text" class="form-control" :placeholder="$t('string.msg.company.label.street')" />
                                        </div>
                                        <div class="form-group col-sm-2">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.number')}}
                                            </label>
                                            <input v-model="data.address.number" type="text" class="form-control" :placeholder="$t('string.msg.company.label.number')" />
                                        </div>
                                    </div>
                                    
                                    <div v-if="data.address.cep && data.address.cep.length == 9" class="form-row ">
                                        <div class="form-group col-sm-5">
                                            <label>
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.neighborhood')}}
                                            </label>
                                            <input v-model="data.address.neighborhood" type="text" class="form-control" :placeholder="$t('string.msg.company.label.neighborhood')" />
                                        </div>
                                        <div class="form-group col-sm-4">
                                            <label>
                                                {{$t('string.msg.company.label.complement')}}
                                            </label>
                                            <input v-model="data.address.complement" type="text" class="form-control" :placeholder="$t('string.msg.company.label.complement')" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.type')}}
                                            </label>
                                            <div class="d-flex flex-wrap">
                                                <div class="container-switch" v-bind:key="item.id" v-for="item in this.types">
                                                    <label class="switch">
                                                        <input 
                                                            v-model="data.typeService" 
                                                            type="checkbox"
                                                            :id="item._id" 
                                                            :value="item._id"
                                                            :true-value="item._id"
                                                            :false-value="null"
                                                            >
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <span class="label-swith">{{(item.name)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div id="accordion" v-if="data.certifies && data.certifies.length>0">
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                                    {{$t('string.msg.companies.list.certifie.label')}}
                                                    </span>
                                                </h5>
                                            </div>
                                            <div class="form-row" >
                                                <div class="form-group col-md-12">
                                                    <div  id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                                                        <div class="card-body">
                                                            <div class="d-flex flex-wrap">
                                                                <div class="container-switch" v-bind:key="item.id" v-for="item in certifies">
                                                                    <label class="switch">
                                                                        <input 
                                                                            v-model="data.certifies" 
                                                                            type="checkbox"
                                                                            :id="item._id" 
                                                                            :value="item._id"
                                                                            :true-value="item._id"
                                                                            :false-value="null"
                                                                            >
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <span class="label-swith">{{camelize(item.name).split('ZZZ_').join('')}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                  
                                    <div id="accordionService" v-if="data.serviceFamilies && data.serviceFamilies.length>0" >
                                        <div class="card">
                                            <div class="card-header" id="headingTwoService">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwoService" aria-expanded="true" aria-controls="collapseTwoService">
                                                    {{$t('string.msg.companies.list.services.label')}}
                                                    </span>
                                                </h5>
                                            </div>
                                            <div class="form-row" >
                                                <div class="form-group col-md-12">
                                                    <div id="collapseTwoService" class="collapse show" aria-labelledby="headingTwoService" data-parent="#accordionService">
                                                        <div class="card-body">
                                                            <div class="d-flex flex-wrap">
                                                                <div class="container-switch" v-bind:key="item.id" v-for="item in services">
                                                                    <label class="switch">
                                                                        <input 
                                                                            v-model="data.serviceFamilies" 
                                                                            type="checkbox"
                                                                            :id="item._id" 
                                                                            :value="item._id"
                                                                            :true-value="item._id"
                                                                            :false-value="null"
                                                                            >
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <span class="label-swith">{{camelize(item.name).split('ZZZ_').join('')}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div id="accordionTableTrailer" v-if="data.manufacturerFamilies && data.manufacturerFamilies.length>0 && listManufacturer().length>0" >
                                        <div class="card">
                                            <div class="card-header" id="headingTwoTableTrailer">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwoTableTrailer" aria-expanded="true" aria-controls="collapseTwoTableTrailer">
                                                    {{$t('string.msg.companies.list.parts.trucktrailer.label')}}
                                                    </span>
                                                </h5>
                                            </div>
                                            <div class="form-row" >
                                                <div class="form-group col-md-12">
                                                    <div id="collapseTwoTableTrailer" class="collapse show" aria-labelledby="headingTwoTableTrailer" data-parent="#accordionTableTrailer">
                                                        <div style="height: 250px; overflow: auto; position: relative; display: block;">
                                                            <table class="table table-bordered table-striped" >
                                                                <thead class="thead-dark">
                                                                    <tr>
                                                                        <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.manufactur')}}</th>
                                                                        <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.family')}}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody v-bind:key="item" v-for="item in listManufacturer()">
                                                                    <tr v-bind:key="item2" v-for="item2 in listFamilies(item)" >
                                                                        <td>{{item.manufacturer.name}}</td>
                                                                        <td>{{camelize(item2.name)}}</td> 
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div id="accordionTableTruckTrailer" v-if="data.manufacturerFamilies && data.manufacturerFamilies.length>0 &&  listManufacturerTruck().length>0" >
                                        <div class="card">
                                            <div class="card-header" id="headingTwoTableTruckTrailer">
                                                <h5 class="mb-0">
                                                    <span class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwoTableTruckTrailer" aria-expanded="true" aria-controls="collapseTwoTableTruckTrailer">
                                                    {{$t('string.msg.companies.list.parts.truck.label')}}
                                                    </span>
                                                </h5>
                                            </div>
                                            <div class="form-row" >
                                                <div class="form-group col-md-12">
                                                    <div id="collapseTwoTableTruckTrailer" class="collapse show" aria-labelledby="headingTwoTableTruckTrailer" data-parent="#accordionTableTruckTrailer">
                                                            <div style="height: 250px; overflow: auto; position: relative; display: block;">
                                                                <table class="table table-bordered table-striped" >
                                                                <thead class="thead-dark">
                                                                    <tr>
                                                                        <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.manufactur')}}</th>
                                                                        <th scope="col">{{$t('string.msg.parts.perfil.truck.table.header.family')}}</th>
                                                                    </tr>
                                                                </thead>
                                                                 <tbody v-bind:key="item" v-for="item in listManufacturerTruck()">
                                                                    <tr v-bind:key="item2" v-for="item2 in listFamiliesTruck(item)" >
                                                                        <td>{{item.manufacturer.name}}</td>
                                                                        <td>{{camelize(item2.name)}}</td> 
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/><br/> -->

                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>

                                    <br/>

                                    <div class="form-row text-center">
                                        <div class="form-group col-md-6">
                                            <button @click="clearForm" class="btn btn-secondary w-50">{{$t('string.msg.form.btn.clear')}}</button>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <button v-if="data.address.cep && data.address.cep.length == 9"  @click="checkForm" class="btn btn-danger w-50">{{$t('string.msg.form.btn.save')}}</button>
                                            <button v-else-if="!data.address.cep || data.address.cep.length < 9" class="btn btn-light w-50">{{$t('string.msg.form.btn.save')}}</button>
                                        </div>
                                    </div>
                                    
                                </form>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem"/>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive"/>
        <FlashMessage/>
    </div>
</template>

<script>
import Controller from './CrtCompany';
import List from './ListCompanies';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Confirmation from '../../../components/layout/Confirmation';
import Vue from 'vue';
Vue.prototype.$eventHub = new Vue();
export default {
  name: 'User',
  components: {
    Spinner,
    Toast,
    List,
    Confirmation
  },
  data() {
      return {
        errors: [],
        addresses: [],
        valuekey: 0,
        certifies:[],
        services:[],
        manufacturer: -1,
        manufacturersTruck: [],
        manufacturersTruckTrailer: [],
        familiesTruck: [],
        familiesTruckTrailer: [],
        manufacturerFamilies: [],
        types: [
            {_id:"PART_SUPPLIER", name:this.$t('string.msg.company.label.type.autoparts')},
            {_id:"CERTIFIER", name:this.$t('string.msg.company.label.type.certifier')},
            {_id:"SERVICE_PROVIDER", name:this.$t('string.msg.company.label.type.serviceprovider')},
            {_id:"FLEET_DRIVER", name:this.$t('string.msg.company.label.type.fleetdriver')}
        ],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        manufacturers: [],
        families: [],
        lastDocument: null,
        data: {
            status: "ACTIVE",
            isBranch: false,
            fantasyName: null,
            socialName: null,
            email: null,
            document: null,
            address: {
                state: -1,
                cep: null,
                city: null,
                address: null,
                neighborhood: null,
                number: null
            },
            primaryPhone: null,
            secondaryPhone: null,
            talkTo: null,
            typeService: [],
            manufacturers: [],
            families: [],
            manufacturerFamilies: []

        }
      }
  },
  methods: Controller.methods,
  created() {
   
  },
  mounted(){
      Controller.init(this);
  }
}
</script>

<style>
</style>
